import React from 'react';
// import React, { Component } from 'react';
import { Field } from 'redux-form';

import classes from '../../../utils/cssClasses';
import RenderField from '../RenderField';


// export default AlignamentRepeater;
export default function({fields}){
	return (
		<div >
	    {fields.map((alignament, index) =>
	      <div className={classes('card')} key={index}>
	      	<div className={classes('card-body')} key={index}>
		        <h4>
		        	Alignament #{index + 1}
			        <button
			          type="button"
			          title="Remove Alignament"
			          className={classes('btn btn-link')}
			          onClick={() => fields.remove(index)}>
			          Rimuovi
			         </button>
			      </h4>
		        <div className={classes('row')}>
		        	<div className={classes('col-12 col-md-6')}>
				        <Field
				          name={`${alignament}.targetName`}
				          type="text"
				          label="Name"
				          component={RenderField}
				          placeholder="Name"/>
		        	</div>
		        	<div className={classes('col-12 col-md-6')}>
				        <Field
				          name={`${alignament}.targetUrl`}
				          type="text"
				          label="Url"
				          required
				          component={RenderField}
				          placeholder="Url"/>

		        		<small>URL linking to the official description of the alignment target, for example an individual standard within an educational framework.</small>
		        		<small>If you want you can put the url of the BadgeClass, if it isn't created already you can leave it blank and fill it later</small>
		        		<small>Remember that this field is mandatory to the validation of the BadgeClass.</small>
		        	</div>
		        	<div className={classes('col-12 ')}>
				        <Field
				          name={`${alignament}.targetDescription`}
				          label="Description"
				          type="textarea"
				          component={RenderField}
				          placeholder="Description"/>
		          </div>
		        	<div className={classes('col-12 col-md-6')}>
				        <Field
				          name={`${alignament}.targetFramework`}
				          label="Framework"
				          type="text"
				          component={RenderField}
				          placeholder="Framework"/>
		        		<small>URL linking to the official description of the alignment target, for example an individual standard within an educational framework.</small>
		        	</div>
		        	<div className={classes('col-12 col-md-6')}>
				        <Field
				          name={`${alignament}.targetCode`}
				          label="Code"
				          type="text"
				          component={RenderField}
				          placeholder="Last Name"/>
		        		<small>If applicable, a locally unique string identifier that identifies the alignment target within its framework and/or .</small>
		        	</div>
		        </div>
		      </div>
		    </div>
	    )}
	    <button className={classes('btn btn-dark mt-3 mb-3')} type="button" onClick={() => {
	    	fields.push({})
	    	console.log(fields.length);
	    }}>Add item</button>
	  </div>
	);
}


// WEBPACK FOOTER //
// ./src/components/Backend/AlignamentRepeater/AlignamentRepeater.js